/**
 * Ekran odmowy dostępu do modułu aplikacji HR.
 *
 * Do Etapu 9 rola bez uprawnienia, która trafiła na trasę modułu z ręki (wpisany
 * adres, zakładka, stary link), widziała generyczne „Nie udało się wczytać" —
 * bo pierwsze żądanie kończyło się 403 i ekran raportował je jak awarię. To
 * kłamstwo o przyczynie: dane są, tylko nie dla tej roli.
 *
 * Ekran mówi wprost, że brakuje uprawnienia, i podaje wyjście: pierwszy moduł,
 * który ta rola faktycznie może otworzyć, albo portal pracownika. Nie wymienia
 * nazw ról ani tego, co w środku jest — komunikat odmowy nie może być mapą
 * uprawnień dla kogoś, kto ich nie ma.
 */
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Button, Card, Shield } from '@k1p4/ui'
import { firstAllowedAppPath } from '../../nav'
import { useAuth } from '../../auth/AuthProvider'
import styles from './AccessDenied.module.css'

export function AccessDenied() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { session } = useAuth()

  const fallback = firstAllowedAppPath(session?.user.roles ?? [])
  const target = fallback ?? '/me'

  return (
    <Card pad="lg" className={styles.card}>
      <span className={styles.icon} aria-hidden="true">
        <Shield size={28} />
      </span>
      <h2 className={styles.title}>{t('accessDenied.title')}</h2>
      <p className={styles.body}>{t('accessDenied.body')}</p>
      <Button onClick={() => void navigate(target, { replace: true })}>
        {t(fallback === null ? 'accessDenied.ctaPortal' : 'accessDenied.cta')}
      </Button>
    </Card>
  )
}
